import { BASE_COLUMN_TYPES, BaseColumnType } from "../../columns/config/types";
import { ReportColumnConfigBase } from "../../columns/config/ReportColumnConfig";

import {
  PresentationNumberColumn,
  ClientColumn,
  ProjectColumn,
  BudgetColumn,
  OrderDateColumn
} from "../common";

export const Columns: ReportColumnConfigBase<BaseColumnType>[] = [
  PresentationNumberColumn,
  ClientColumn,
  ProjectColumn,
  BudgetColumn,
  OrderDateColumn,
];
